import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const CRYSTAL = "#67c4d8";
const CRYSTAL_HI = "#bfeaf2";

function gemUnit(cx: number, cy: number, cz: number, s: number, c: string, hi: string): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(s, 0), color: c, position: [cx, cy, cz], scale: [1, 1.25, 1] as const },
    { geometry: new THREE.IcosahedronGeometry(s * 0.5, 0), color: hi, position: [cx, cy + s * 0.55, cz] },
  ];
}

export const crystalGem = defineModel({
  id: "crystal-gem",
  batchId: "characters",
  name: "Crystal gem",
  tags: ["good", "cargo", "precious"],
  fits: ["carry"],
  summary: "A pair of raw crystals -- a carriable good for an avatar's carry socket.",
  description:
    "Two crystals with highlights at held scale, ported from age-of-mcp's goods " +
    "(`crystal`). Mount it in a player's or worker's `carry` socket to show the " +
    "figure hauling crystals.",
  author: "age-of-mcp",
  footprint: 0.06,
  parts: (): Part[] => [
    ...gemUnit(0, 0.04, 0.01, 0.05, CRYSTAL, CRYSTAL_HI),
    ...gemUnit(0.045, 0.025, 0.02, 0.032, CRYSTAL, CRYSTAL_HI),
  ],
  animations: [],
});
